import axios from "axios";
import { FETCH_CONTRACT, HANDLE_ERRORS, LOADING_MODE } from "./types";
import BASE_URL from '../helpers/base-url';

export const getContract = (start, end) => async dispatch => {
  try {
    dispatch({ type: LOADING_MODE, payload: true });
    //const response = await axios.get(`${BASE_URL}/api/file/contract`, authorizeRequest());
    const URL = `${BASE_URL}/api/external/contract/?from=${start}&to=${end}&agg=avg&period=1m`;
    const response = await axios.get(URL);

    dispatch({
      type: HANDLE_ERRORS,
      payload: { message: "", open: false }
    });
    await dispatch({
      type: FETCH_CONTRACT,
      payload: response
    });
    dispatch({ type: LOADING_MODE, payload: false });
  } catch (error) {
    console.error("error fetching contract api");
    dispatch({
      type: HANDLE_ERRORS,
      payload: { message: error.message, open: true }
    });
    dispatch({ type: LOADING_MODE, payload: false });
  }
};



// WEBPACK FOOTER //
// ./src/actions/getContract.js